// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__o7lRc","description":"PatientConsentPreview_description__2gNyQ"};